module.exports = __webpack_public_path__ + "a4982a05be737f89058eadaa87bccea5.png";